import React, { useContext } from 'react';
import Style from './About.module.scss';
import Terminal from "./Terminal";
import {Box} from "@mui/material";
import {useInfo} from "../../info/Info";
import { LanguageContext } from '../../context/LanguageContext';

export default function About({innerRef}) {
    const info = useInfo();
    const { language } = useContext(LanguageContext);
    const firstName = info.firstName.toLowerCase()

    const aboutStr = language === 'pt' ? 'sobre' : 'about';
    const skillsStr = language === 'pt' ? 'habilidades/ferramentas' : 'skills/tools';
    const hobbiesStr = language === 'pt' ? 'hobbies/interesses' : 'hobbies/interests';

    function aboutMeText() {
        return <>
            <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cat
                {' '}{aboutStr}{firstName} </p>
            <p><span style={{color: info.baseColor}}>{aboutStr}{firstName} <span
                className={Style.green}>(main)</span> $ </span>
                {info.bio}
            </p>
        </>;
    }

    function skillsText() {
        return <>
            <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cd {skillsStr}
            </p>
            <p><span style={{color: info.baseColor}}>{skillsStr} <span
                className={Style.green}>(main)</span> $</span> ls</p>
            {Object.keys(info.skills).map((key, index) => {
                return (
                    <React.Fragment key={index}>
                        <p style={{color: info.baseColor}}> {key}</p>
                        <ul className={Style.skills}>
                            {info.skills[key].map((skill, idx) => <li key={idx}>{skill}</li>)}
                        </ul>
                    </React.Fragment>
                );
            })}
        </>;
    }

    function miscText() {
        return <>
            <p><span style={{color: info.baseColor}}>{firstName}{info.lastName.toLowerCase()} $</span> cd
                {' '}{hobbiesStr}</p>
            <p><span style={{color: info.baseColor}}>{hobbiesStr} <span
                className={Style.green}>(main)</span> $</span> ls</p>
            <ul>
                {info.hobbies.map((hobby, index) => (
                    <li key={index}><Box component={'span'} mr={'1rem'}>{hobby.emoji}</Box>{hobby.label}</li>
                ))}
            </ul>
        </>;
    }

    return (
        <Box ref={innerRef} display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'} id={'about'}>
            <Terminal text={aboutMeText()}/>
            <Terminal text={skillsText()}/>
            <Terminal text={miscText()}/>
        </Box>
    )
}